import {remCalc} from '_themeUtils'

const animatedSlide = {
    AnimatedSlide: {
        baseStyle: ({headerSize, headerSizeNotCollapsed, accessibilityBannerSize}) => ({
            container: {
                w: '100%',
                boxSizing: 'border-box',
                h: {
                    base: `calc(100dvh - ${(headerSize.base || 0) - (accessibilityBannerSize.base || 0)}px)`,
                    sm: `calc(100dvh - ${(headerSize.sm || 0) - (accessibilityBannerSize.sm || 0)}px)`,
                    md: `calc(100dvh - ${(headerSize.md || 0) - (accessibilityBannerSize.md || 0)}px)`,
                    lg: `calc(100dvh - ${(headerSize.lg || 0) - (accessibilityBannerSize.lg || 0)}px)`,
                    xl: `calc(100dvh - ${accessibilityBannerSize.xl || 0}px)`,
                    '2xl': `calc(100dvh - ${accessibilityBannerSize['2xl'] || 0}px)`,
                },
                position: 'relative',

                '&.not-on-first-slide': {
                    boxSizing: 'content-box',
                    pb: 0,
                    mt: {
                        base: `-${headerSizeNotCollapsed.base + accessibilityBannerSize.base - headerSize.base}px`,
                        sm: `-${headerSizeNotCollapsed.sm + accessibilityBannerSize.sm - headerSize.sm}px`,
                        md: `-${headerSizeNotCollapsed.md + accessibilityBannerSize.md - headerSize.md}px`,
                        lg: `-${headerSizeNotCollapsed.lg + accessibilityBannerSize.lg - headerSize.lg}px`,
                        xl: 0,
                        '2xl': 0,
                    },
                },

                '.swiper': {
                    w: '100%',
                    h: '100%',

                    '.swiper-slide': {
                        overflowY: 'auto',
                        WebkitOverflowScrolling: 'touch',
                    },

                    '.swiper-slide:not(:first-child)': {
                        pt: {
                            xl: `${headerSize.xl - (accessibilityBannerSize.xl * 2 || 0)}px`,
                            '2xl': `${headerSize['2xl'] - (accessibilityBannerSize['2xl'] * 2 || 0)}px`,
                        },
                    },

                    '.swiper-pagination': {
                        right: 'spacing.8',

                        '.swiper-pagination-bullet': {
                            w: remCalc(6),
                            h: remCalc(6),
                            my: 'spacing.2',
                            background: 'rgba(255, 255, 255, 0.3)',
                        },

                        '.swiper-pagination-bullet-active': {
                            background: 'color.border.white',
                        },
                    },
                },
            },
            moduleItemWrapper: {
                h: {base: '0', md: '100%'},
                minH: {base: '100%', md: 'unset'},
                display: 'flex',
                alignItems: 'center',
                background: 'color.border.white',
                overflow: {base: 'visible', lg: 'hidden'},
            },
        }),
    },
}

export default animatedSlide
